import { render, staticRenderFns } from "./PainelRegras.vue?vue&type=template&id=28816842&scoped=true"
import script from "./PainelRegras.vue?vue&type=script&lang=js"
export * from "./PainelRegras.vue?vue&type=script&lang=js"
import style0 from "./PainelRegras.vue?vue&type=style&index=0&id=28816842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28816842",
  null
  
)

export default component.exports